import { useState } from "react"
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TableSortLabel
} from "@mui/material"
import { TokenRequest } from "../entities/token-request"

export interface TokenRequestsProps {
    tokenRequests: TokenRequest[];
    onRowClick: (tokenRequestId: string) => void;
    showAdminInfos?: boolean;
}

export const TokenRequests = ({ tokenRequests, onRowClick, showAdminInfos = false }: TokenRequestsProps) => {
    const [order, setOrder] = useState<'asc' | 'desc'>('asc')
    const [orderBy, setOrderBy] = useState<string>('requestingUser')

    const handleRequestSort = (property: string) => {
        const isAsc = orderBy === property && order === 'asc'
        setOrder(isAsc ? 'desc' : 'asc')
        setOrderBy(property)
    }

    const sortedTokenRequests = [...tokenRequests].sort((a: any, b: any) => {
        if (a[orderBy] < b[orderBy]) return order === 'asc' ? -1 : 1
        if (a[orderBy] > b[orderBy]) return order === 'asc' ? 1 : -1
        return 0
    })

    return (
        <TableContainer>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell>
                            <TableSortLabel
                                active={orderBy === 'requestingUser'}
                                direction={orderBy === 'requestingUser' ? order : 'asc'}
                                onClick={() => handleRequestSort('requestingUser')}
                            >
                                Requester
                            </TableSortLabel>
                        </TableCell>
                        <TableCell>
                            <TableSortLabel
                                active={orderBy === 'requestedQuantity'}
                                direction={orderBy === 'requestedQuantity' ? order : 'asc'}
                                onClick={() => handleRequestSort('requestedQuantity')}
                            >
                                Quantity
                            </TableSortLabel>
                        </TableCell>
                        <TableCell>
                            <TableSortLabel
                                active={orderBy === 'requestDate'}
                                direction={orderBy === 'requestDate' ? order : 'asc'}
                                onClick={() => handleRequestSort('requestDate')}
                            >
                                Request date
                            </TableSortLabel>
                        </TableCell>
                        <TableCell>
                            <TableSortLabel
                                active={orderBy === 'status'}
                                direction={orderBy === 'status' ? order : 'asc'}
                                onClick={() => handleRequestSort('status')}
                            >
                                Status
                            </TableSortLabel>
                        </TableCell>
                        {showAdminInfos && (
                            <>
                                <TableCell>
                                    <TableSortLabel
                                        active={orderBy === 'lastModifiedAt'}
                                        direction={orderBy === 'lastModifiedAt' ? order : 'asc'}
                                        onClick={() => handleRequestSort('lastModifiedAt')}
                                    >
                                        Update date
                                    </TableSortLabel>
                                </TableCell>
                                <TableCell>
                                    <TableSortLabel
                                        active={orderBy === 'lastModifiedBy'}
                                        direction={orderBy === 'lastModifiedBy' ? order : 'asc'}
                                        onClick={() => handleRequestSort('lastModifiedBy')}
                                    >
                                        Update user
                                    </TableSortLabel>
                                </TableCell>
                                <TableCell>
                                    <TableSortLabel
                                        active={orderBy === 'proofOfPaymentName'}
                                        direction={orderBy === 'proofOfPaymentName' ? order : 'asc'}
                                        onClick={() => handleRequestSort('proofOfPaymentName')}
                                    >
                                        Proof
                                    </TableSortLabel>
                                </TableCell>
                            </>
                        )}
                    </TableRow>
                </TableHead>
                <TableBody>
                    {sortedTokenRequests.map((tokenRequest) => (
                        <TableRow hover key={tokenRequest.id} onClick={() => onRowClick(tokenRequest.id)}>
                            <TableCell>{tokenRequest.requestingUser}</TableCell>
                            <TableCell>{tokenRequest.requestedQuantity}</TableCell>
                            <TableCell>{new Date(tokenRequest.requestDate).toLocaleString("fr-be")}</TableCell>
                            <TableCell>{tokenRequest.status}</TableCell>
                            {showAdminInfos && (
                                <>
                                    <TableCell>{new Date(tokenRequest.lastModifiedAt).toLocaleString("fr-be")}</TableCell>
                                    <TableCell>{tokenRequest.lastModifiedBy}</TableCell>
                                    <TableCell>{tokenRequest.proofOfPaymentName}</TableCell>
                                </>
                            )}
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    )
}